import { ButtonColorProps } from '~/lib';
import { BLACK_FRIDAY_THEME, CHRISTMAS_THEME } from '~/theme/constants';

export const baseVariantMap: Record<string, ButtonColorProps> = {
    '#ffffff': 'primary-inverse',
    '#fff': 'primary-inverse',
    white: 'primary-inverse',
    [BLACK_FRIDAY_THEME]: 'black-friday',
    [CHRISTMAS_THEME]: 'christmas',
};

export const linkTypeVariantMap: Record<
    'Text' | 'Secondary' | 'Default',
    Record<string, ButtonColorProps>
> = {
    Text: {
        [BLACK_FRIDAY_THEME]: 'new-link-black-friday',
        [CHRISTMAS_THEME]: 'new-link-christmas',
        default: 'new-link',
    },
    Secondary: {
        default: 'new-secondary',
    },
    Default: {
        [BLACK_FRIDAY_THEME]: 'black-friday',
        [CHRISTMAS_THEME]: 'christmas',
        default: 'primary',
    },
};
